import { Button } from '@akin-home/buttons/native';
import { ChatResponseOption } from '@akin-home/chat';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import styled from 'styled-components/native';
import { ChatItemComponents } from '.';
import { ChatTextItem } from '../../../ChatItem/types';
import { useFocusedChatState } from '../../hooks/useFocusedChatState';

type Props = {
  item: ChatTextItem;
  index: number;
  onPressOption?(option: ChatResponseOption, index: number): void;
};

export function ChatItemText(props: Props) {
  const { item, index } = props;

  const onPressDoneMultiselect = useFocusedChatState(
    (state) => state.doneMultiselect
  );
  const onPressSkipMultiselect = useFocusedChatState(
    (state) => state.skipMultiselect
  );

  const {
    data: { text, options, image_url },
    commands,
  } = item;

  const multiselect_command = commands?.find(
    (command) => command.type === 'multiselect_actions'
  );

  function onPressOption(option: ChatResponseOption) {
    props.onPressOption?.(option, index);
  }

  function onSkip() {
    const skip_message = multiselect_command.data.skip;
    if (skip_message) {
      onPressSkipMultiselect?.(skip_message, index);
    }
  }

  function onDone() {
    const done_message = multiselect_command.data.next;
    if (done_message) {
      onPressDoneMultiselect?.(done_message, index);
    }
  }

  return (
    <Container>
      {image_url ? <Image source={{ uri: image_url }} /> : null}

      {text ? (
        <TextBlockRow>
          <ChatItemTextBlock>
            <Text>{item.data.text}</Text>
          </ChatItemTextBlock>
        </TextBlockRow>
      ) : null}

      {options ? (
        <ChatItemComponents.Options
          options={options}
          onPressOption={onPressOption}
        />
      ) : null}

      {multiselect_command && !item.data.disabled ? (
        <MultiselectActions>
          {multiselect_command.data.next ? (
            <Button size="large" onPress={onDone}>
              Done
            </Button>
          ) : null}
          {multiselect_command.data.skip ? (
            <Button size="large" variant="secondary" onPress={onSkip}>
              Skip
            </Button>
          ) : null}
        </MultiselectActions>
      ) : null}
    </Container>
  );
}

const TextBlockRow = styled.View`
  flex-direction: row;
`;

const Container = styled.View`
  gap: 12px;
`;

export const ChatItemTextBlock = styled.View`
  background-color: ${colors.grey[200]};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 16px;
`;

const MultiselectActions = styled.View`
  flex-direction: row;
  gap: 10px;
`;

const Image = styled.Image`
  height: 300px;
`;
